import { TransformedQuery } from './transformed-query';
import { QueryTransformer } from './query-transformer';

/**
 * implements basic querytransformer features to handle composite/single queries.
 */
export abstract class AbstractQueryTransformer implements QueryTransformer {
  /**
   * detection pattern.
   */
  abstract pattern: RegExp;

  /**
   * transforms the given query by pattern recursively.
   * @param query
   */
  transform(query: TransformedQuery): TransformedQuery {
    let newQuery = query;

    // transform format to harmonized format
    if (query.composite) {
      newQuery = new TransformedQuery(query.parts.map((part) => (!part.final ? this.transform(part) : part)));
    } else {
      const match = query.toString().match(this.pattern);
      if (match !== null) {
        newQuery = this.getTransformedQueryByParts(match);
      }
    }

    return newQuery;
  }

  /**
   * build a new query with the detected parts of the regex matching results.
   * @param queryParts
   */
  abstract getTransformedQueryByParts(queryParts: RegExpMatchArray): TransformedQuery;
}
